const Info = () => {

    return (
        <div className='basicInfo'>
            <p>
            I am a fourth-year software engineering student from Helsinki, Finland who's always looking for more information and skills to add to my toolbox. 
            I've always been a huge fan of electronics and software: anything from videogames to tiny widgets interests me greatly. 
            My current obsession is with different controller interfaces: touch screens, smart homes, knobs and sliders.<br/>
            <br/>
            I am currently studying in Metropolia University of Applied Sciences 
            for my Bachelor's of Software Engineering and will graduate by the end of 2026. 
            <br/>
            <br/>
            I have no problems working in stressful or rushed environments. My first Internship was at <a href="https://www.airbus.com/en/products-services/defence" target="_blank" rel="noreferrer">Airbus Defence & Space's</a> Helsinki's Lab Testing team. During my internship I learned about SCRUM in a real working environment.
            The job offered lots of experience in physical networking architecture but most of my time was spent programming internal software and scripts for the team in Python. Other technologies included automated testing and scripts for different shells.<br/>
            The internship culminated to a full stack project where the Python program was matched with Mysql, React and NodeJS, with a bit of server managing and Nginx configuration.
            </p>
        </div>
    );

}

export default Info;